import { ID_YOUTUBE_IFRAME_SCRIPT } from '@www/_models';

export function addYoutubeIframeScript(): boolean {
  if (document.getElementById(ID_YOUTUBE_IFRAME_SCRIPT)) {
    return true;
  }
  const tag = document.createElement('script');
  tag.id = ID_YOUTUBE_IFRAME_SCRIPT;
  tag.src = 'https://www.youtube.com/iframe_api';
  document.body.appendChild(tag);
  return true;
}
